import * as React from 'react';

interface BoundingRect {
    top: number;
    left: number;
    bottom: number;
    right: number;
    width: number;
    height: number;
}

export function useBoundingRect(
    listRef: React.RefObject<HTMLDivElement>,
): BoundingRect | undefined {
    const [boundingRect, setBoundingRect] = React.useState<BoundingRect>();

    React.useEffect(() => {
        const handleResize = () => {
            if (listRef.current) {
                setBoundingRect(listRef.current.getBoundingClientRect());
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [listRef?.current]);

    return boundingRect;
}
